import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../../store"
import { Labels } from "../../../../util/Translations"
import { WorkspacesInfo } from "../../index"

type StateProps = WorkspacesInfo

type Props = StateProps

export const NothingFound = ({ filter }: Props): JSX.Element => {
    const { NoWorkspacesFoundFiltered, NoWorkspacesFound } = Labels

    return (
        <li className="tw-my-1 tw-py-1 tw-px-3 text-dimmed">
            {filter.length > 0 ? NoWorkspacesFoundFiltered : NoWorkspacesFound}
        </li>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage.workspacesInfo,
})

export default connect(mapStateToProps, {})(NothingFound)
